module.exports = __webpack_public_path__ + "img/20_26.95930f63.png";